import { supabase } from "../../Services/supabaseClient";

export const getContacts = async (companyId) => {
  const { data, error } = await supabase
    .from("crm_contacts")
    .select(
      `
      *,
      crm_accounts(id, name)
    `
    )
    .eq("company_id", companyId)
    .order("full_name", { ascending: true });

  if (error) {
    throw error;
  }

  return data || [];
};

export const createContact = async (payload) => {
  const { data, error } = await supabase
    .from("crm_contacts")
    .insert([payload])
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateContact = async (contactId, companyId, payload) => {
  const { data, error } = await supabase
    .from("crm_contacts")
    .update(payload)
    .eq("id", contactId)
    .eq("company_id", companyId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteContact = async (contactId, companyId) => {
  const { error } = await supabase
    .from("crm_contacts")
    .delete()
    .eq("id", contactId)
    .eq("company_id", companyId);

  if (error) {
    throw error;
  }

  return true;
};
